import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import styles from './SaveToAllOutletsModal.css'
import {hideSaveToAllOutletsModal} from 'actions/ingredients/library'
import {connect} from 'react-redux'

class SaveToAllOutletsModal extends React.Component {
  render () {
    const {showSaveToAllOutletsModal, createdOutlets} = this.props

    return (
      <Modal show={showSaveToAllOutletsModal} backdrop='static' onHide={this._onClickDone} dialogClassName={`modal-dialog ${styles.dialog}`}>
        <ModalHeader title={'Save to All Outlets'} />
        <Modal.Body>
          <div className={styles['sub-title']}>
            Ingredient successfully saved to:
          </div>
          {createdOutlets && createdOutlets.outletsSuccess.map((outlet) => {
            return <div className={styles['block-outlets']}>
              <div className='row'>
                <div className='col-md-11'>
                  {outlet.name}
                </div>
                <div className='col-md-1'>
                  <i className='fa fa-check-circle' />
                </div>
              </div>
            </div>
          })}
        </Modal.Body>
        <Modal.Footer>
          {createdOutlets && createdOutlets.outletsFailed.length > 0 &&
            <span className={styles['failed-all-outlets']}>
              Ingredient failed to be saved on one or several outlets. There may be one or more conflict in your ingredient attributes (Ingredient name and unit)
            </span>
          }
          <span className='pull-right'>
            <button className='btn btn-primary' onClick={this._onClickDone}>
              Done
            </button>
          </span>
        </Modal.Footer>
      </Modal>)
  }

  _onClickDone = () => {
    this.props.dispatch(hideSaveToAllOutletsModal())
  }
}

function mapStateToProps (state) {
  const {showSaveToAllOutletsModal, createdOutlets} = state.ingredients.library
  return {
    showSaveToAllOutletsModal,
    createdOutlets
  }
}

export default connect(mapStateToProps)(SaveToAllOutletsModal)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/SaveToAllOutletsModal/SaveToAllOutletsModal.js